import { computed } from 'vue'
import useFeatureFlagStore from '@shared/stores/useFeatureFlagStore'
import useUserStore from '@shared/stores/useUserStore'

export default function usePreSubscriptionWebOptimizedFunnel() {
  const featureFlagStore = useFeatureFlagStore()
  const userStore = useUserStore()
  return computed(
    () =>
      featureFlagStore.flags.webOptimizedFunnel &&
      userStore.user?.currentSubscription == null,
  )
}
